// Conteúdo e imagens do book Urban Square, versão 16/06/2026.
// Espaços comuns preparados conforme projeto; mobiliário e equipamentos não inclusos.
export const projectGallery = [
  { src: "/assets/facade-main.webp", alt: "Perspectiva ilustrativa da fachada do Urban Square" },
  { src: "/assets/facade-detail.webp", alt: "Detalhe da arquitetura do Urban Square" },
  { src: "/assets/entrance.webp", alt: "Perspectiva ilustrativa do acesso ao Urban Square" },
  { src: "/assets/urban-garden.webp", alt: "Jardim Urban integrado ao acesso do empreendimento" },
];

export const amenities = [
  ["Terraço lúdico", "/assets/terrace.webp", "Um espaço ao ar livre preparado para pausas, convivência e novas possibilidades de uso. Ambientação e equipamentos ilustrativos, não inclusos na entrega."],
  ["Salão de festas", "/assets/party-room.webp", "No rooftop, uma área preparada para encontros e celebrações. Mobiliário, equipamentos e composição gourmet ficam a critério do condomínio após a entrega."],
  ["Coworking", "/assets/coworking.webp", "Infraestrutura prevista para apoiar estudo, trabalho e concentração no próprio condomínio. Mesas, cadeiras e equipamentos não fazem parte da entrega."],
  ["Lavanderia", "/assets/laundry.webp", "Área preparada para futura instalação de equipamentos de lavagem e secagem, conforme definição do condomínio. Máquinas e mobiliário não estão inclusos."],
  ["Bicicletário", "/assets/bike-room.webp", "Espaço preparado para a guarda de bicicletas e para uma rotina de mobilidade mais prática. Consulte o projeto e o memorial para conhecer a infraestrutura de entrega."],
  ["Jardim Urban", "/assets/urban-garden.webp", "Um espaço de chegada que integra vegetação e fachada, criando uma transição acolhedora entre a cidade e o lar. Imagem ilustrativa; execução conforme projeto."],
].map(([title, image, description]) => ({ title, image, description }));

export const apartments = {
  onebed: {
    label: "1 dormitório",
    title: "Cada espaço acompanha o seu ritmo.",
    description: "Uma configuração funcional, com dormitório definido, sacada gourmet e soluções que simplificam o dia a dia.",
    measure: "25,98 a 27,15 m²",
    image: "/assets/apartment-one-bedroom.webp",
    alt: "Perspectiva ilustrativa de apartamento de um dormitório no Urban Square",
    features: ["Sacada com churrasqueira", "Ponto hidráulico para lavanderia", "Infraestrutura para ar-condicionado"],
  },
  garden: {
    label: "1 dormitório Garden",
    title: "O morar se abre para novas possibilidades.",
    description: "Opções no primeiro pavimento com espaço externo para personalizar a sua experiência de morar. Configurações e áreas variam entre as unidades.",
    measure: "Com garden privativo",
    image: "/assets/apartment-garden.webp",
    alt: "Perspectiva ilustrativa de apartamento Garden no Urban Square",
    features: ["Área externa privativa", "Sacada com churrasqueira", "Fechadura eletrônica"],
  },
};
